enum AuthorizeCodeType {
    OAUTH_AUTHORIZATION_CODE = 'OAUTH_AUTHORIZATION_CODE',
    EMAIL_CONFIRMATION_PIN = 'EMAIL_CONFIRMATION_PIN',
    ACCESS_TOKEN = 'ACCESS_TOKEN'
}

export default AuthorizeCodeType;